<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">出库记录</h3>
            <div class="box-tools pull-right">
              <handle @finish="finish">订单上传</handle>
            </div>
          </div>
          <div class="box-body no-padding">
            <div style="padding-top: 20px;padding-left: 20px;">
              <el-form :inline="true">
                <el-form-item label="关键字搜素">
                  <el-input v-model="query.keyword" placeholder="输入关键字搜素" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="querySelect">查询</el-button>
                </el-form-item>
              </el-form>
            </div>

            <el-table :data="list" border v-loading="listLoading" style="width: 100%">
              <el-table-column prop="order_code" label="单据编号" width="160"></el-table-column>
              <el-table-column prop="type" label="类型" width="100"></el-table-column>
              <el-table-column prop="people" label="制单人" width="80"></el-table-column>
              <el-table-column prop="custom" label="客户"></el-table-column>
              <el-table-column prop="people_handle" label="经办人" width="80"></el-table-column>
              <el-table-column prop="department" label="部门" width="60"></el-table-column>
              <el-table-column prop="warehouse" label="仓库"></el-table-column>
              <el-table-column prop="remark" label="摘要"></el-table-column>
              <el-table-column prop="entry_date" label="录单日期"></el-table-column>
              <el-table-column prop="give_date" label="交货日期"></el-table-column>
              <el-table-column prop="count_price" label="合计"></el-table-column>
              <el-table-column prop="count_num" label="数量" width="60"></el-table-column>
              <el-table-column label="订单产品">
                <template slot-scope="scope">
                  <div>
                    <in-detail :order="scope.row">
                      点击查看 (数量：{{scope.row.product.length}})
                    </in-detail>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div>
                    <delete :id="scope.row.id" @finish="finish">
                      删除
                    </delete>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="padding: 10px">
              <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :total="total"
                  :page-size="query.size"
                  :current-page="query.page"
                  @current-change="pageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import qs from "qs";

import InDetail from "./InDetail.vue";
import Handle from "./Handle.vue";
import Delete from "./Delete.vue";

export default {
  components: {Delete, InDetail, Handle},
  data() {
    return {
      params: {},
      query: {
        keyword: '',
        page: 1,
        size: 10,
      },
      list: [],
      total: 0,
      listLoading: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query);
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.listLoading = true;
    _this.authInit(_this).then(() => {
      _this.loadList();
    });
  },
  methods: {
    ...mapActions(["authInit"]),
    updateUrl() {
      const _this = this;
      const url = _this.$route.path + "?" + qs.stringify(_this.query);
      _this.$router.replace({path: url});
    },
    // 获取列表
    loadList() {
      const _this = this;
      _this.$api.wareOrderList(_this.query)
          .then(res => {
            _this.listLoading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.updateUrl();
          })
          .catch(err => {
            _this.listLoading = false;
            _this.$message.error(err.msg);
          })
    },
    // 分页
    pageChange(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.listLoading = true;
      _this.loadList();
    },
    // 筛选
    querySelect() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
    finish() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>